import { computed } from 'vue'

const defaultGridMenuOptions = {
  apiSettings: {},
  config: {},
  enableExportButton: false,
  enableMultirowSelect: false,
  enablePresets: false,
  enableQuickFilter: true,
  exportButtonSettings: {},
  multirowSelectSettings: {},
  presetsSettings: {},
}

export function useGridConfig(props, siteConfig = {}) {
  const customParams = computed(() => {
    const params = {
      queueName: siteConfig.value?.data?.customParams?.queueName
        || props.queueName
        || 'NOT_SET',
      ...siteConfig.value?.data?.customParams,
    }

    // Only include quickFilterValue if it exists in siteConfig
    // The dynamic value from gridState will be added in ServerSideDataSource
    if (siteConfig.value?.data?.customParams?.quickFilterValue !== undefined) {
      params.quickFilterValue = siteConfig.value.data.customParams.quickFilterValue
    }

    if (siteConfig.value?.data?.esPaginationApiType) params.esPaginationApiType = siteConfig.value.data.esPaginationApiType

    return params
  })

  const gridMenuConfig = computed(() => {
    return {
      ...defaultGridMenuOptions,
      ...props.config,
      ...siteConfig.value?.data,
    }
  })

  const pinnedColumns = computed(() => siteConfig.value?.data?.pinnedColumns || [])

  const serverConfig = computed(() => ({
    baseUrl: siteConfig.value?.data?.apiSettings?.baseUrl || props.config.baseUrl,
    url: siteConfig.value?.data?.apiSettings?.rowsUrl || props.config.rowsUrl,
    ...siteConfig.value?.data?.apiSettings,
  }))

  const showActiveFilters = computed(() =>
    siteConfig.value?.data?.showActiveFilters || props.config?.showActiveFilters || false,
  )

  // eslint-disable-next-line no-unused-vars
  const defaultSortModel = computed(() =>
    siteConfig.value?.data?.defaultSortModel || props.config?.defaultSortModel || [],
  )

  return {
    customParams,
    gridMenuConfig,
    pinnedColumns,
    serverConfig,
    showActiveFilters,
  }
}
